<template>
  <div class="bg-white shadow rounded overflow-hidden">
    <div class="flex flex-col md:flex-row">
      <div class="w-full md:hidden p-6">
        {{ name }}
      </div>
      <div class="flex-1 md:flex-none md:w-64">
        <ProjectAsset :project-asset="approvalRequest.approvable" />
      </div>
      <div class="flex-1 flex flex-col md:flex-row items-center justify-between p-6 md:space-x-4">
        <div class="hidden md:block flex-1 truncate">
          {{ name }}
        </div>
        <div v-if="isPending" class="flex space-x-4 w-full md:w-auto">
          <ReviewAction :approval-request="approvalRequest" class="flex-1 md:flex-auto" />
        </div>
        <div v-else class="text-center md:text-right prose">
          <p>
            You have
            <span :class="['font-medium', isApproved ? 'text-green-600' : 'text-red-600']">
              {{ isApproved ? 'approved' : 'rejected' }}
            </span>
            this approval request on <br class="sm:hidden" />
            {{ submittedAt }}.
          </p>
          <p v-if="isRejected" class="mt-2">
            We are working to meet your requirements.<br />
            You will soon receive a new approval request with the changes.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import ProjectAsset from './ProjectAsset.vue';
import ReviewAction from './ReviewAction.vue';

export default {
  components: {
    ProjectAsset,
    ReviewAction,
  },
  props: {
    approvalRequest: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isApproved() {
      return this.approvalRequest.approvedAt !== null;
    },
    isRejected() {
      return this.approvalRequest.rejectedAt !== null;
    },
    isPending() {
      return !this.isApproved && !this.isRejected;
    },
    name() {
      if (this.approvalRequest.approvableType === 'project_assets') {
        const { asset } = this.approvalRequest.approvable || {};
        if (asset?.media) {
          return asset?.media.name;
        }

        if (asset?.link) {
          return asset?.link.title || asset?.link.url;
        }

        return 'Note';
      }

      return 'Unknown name';
    },
    submittedAt() {
      const [submittedAt] = [
        this.approvalRequest.approvedAt,
        this.approvalRequest.rejectedAt,
      ].filter(Boolean);

      if (!submittedAt) {
        return null;
      }

      const dateSubmitted = moment.utc(submittedAt).local();

      const format = [
        'ddd',
        'D',
        'MMM',
        moment().year() !== dateSubmitted.year() ? 'Y' : false,
        '[at]',
        'h:mm A',
      ]
        .filter(Boolean)
        .join(' ');

      return dateSubmitted.format(format);
    },
  },
};
</script>
